//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Skeleton, Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import translations from './InstallmentSimulation.translations'

export default {
  components: {
    Skeleton,
    Typography,
  },

  props: {
    lineCount: {
      type: Number,
      default: 0,
    },

    /**
     * @typedef {import('@http/transformResponse/transformResponse').InstallmentSimulation}
     */
    simulation: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    translations: () => translations,

    isLoading() {
      return isEmpty(this.simulation)
    },

    lines() {
      if (this.isLoading) {
        return Array.from({ length: this.lineCount }).map((_, i) => i)
      }

      const format = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }

      return [
        {
          date: this.$t.date(new Date(), format),
          translation: this.$t(translations.downAmount, {
            amount: this.$t.price(this.simulation.initial),
          }),
        },
        ...this.simulation.installments.map((installment, index) => ({
          date: this.$t.date(new Date(installment.date), format),
          translation: this.$t(translations.wording, {
            amount: this.$t.price(installment.price),
            number: index + 1,
          }),
        })),
      ]
    },
  },
}
